import BasePage from './BasePage';
import { Box, Container, Typography, Paper, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function Disclaimer() {
  return (
    <BasePage
      title="CribCritic Disclaimer"
      description="Disclaimer for CribCritic AI"
      keywords="disclaimer, legal disclaimer, limitations, advisory"
      canonicalUrl="https://cribcritic.ai/disclaimer"
    >
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link 
            component={RouterLink} 
            to="/" 
            underline="hover" 
            color="inherit"
            zIndex={2001}
            sx={{ 
              '&:hover': { 
                color: 'primary.main',
                cursor: 'pointer' 
              },
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
              Home
            </Box>
          </Link>
          <Typography color="text.primary">Disclaimer</Typography>
        </Breadcrumbs>
        
        <Paper elevation={2} sx={{ p: { xs: 0, md: 0 }, borderRadius: 2 }}>          
          <Box sx={{ width: '100%', height: '800px' }}>
            <iframe 
              src="/Disclaimer.html" 
              title="CribCritic Disclaimer" 
              width="100%" 
              height="100%" 
              frameBorder="0"
              style={{ border: 'none' }}
            />
          </Box>
        </Paper>
      </Container>
    </BasePage>
  );
}

export default Disclaimer;